import React, { createContext, useContext, useState } from 'react';
import { useGetBookmarksQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { useSearchContext } from '../SearchProvider';

export type BookmarkType = {
	id: string;
	uuid: string;
};

export interface BookmarksContextInterface {
	bookmarks: BookmarkType[];
	bookmarksLoading: boolean;
	setBookmarks: React.Dispatch<React.SetStateAction<BookmarkType[]>>;
}

export const BookmarksContext = createContext<BookmarksContextInterface | undefined>(undefined);

export const useBookmarks = () => {
	const context = useContext(BookmarksContext);

	if (context === undefined) {
		throw new Error('useBookmarks must be used within BookmarksProvider.');
	}

	return context;
};

export const BookmarksProvider: React.FC = ({ children }) => {
	const { indexAvailable } = useSearchContext();
	const [bookmarks, setBookmarks] = useState<BookmarkType[]>(undefined);

	const { loading: bookmarksLoading } = useGetBookmarksQuery({
		variables: { version: '2' },
		skip: (bookmarks && Array.isArray(bookmarks)) || !indexAvailable,
		onCompleted: data =>
			setBookmarks(
				data.bookmarks.map(bookmark => {
					return {
						id: bookmark.program.id,
						uuid: bookmark.program.uuid,
					};
				})
			),
	});

	return (
		<BookmarksContext.Provider value={{ bookmarks, bookmarksLoading, setBookmarks }}>
			{children}
		</BookmarksContext.Provider>
	);
};
